import React, { useState } from "react";
import {
  Box,
  createGenerateClassName,
  StylesProvider,
  ThemeProvider,
  Theme,
} from "@material-ui/core";
import { IntlProvider } from "react-intl";
import { Route, Router } from "react-router-dom";
import type { History } from "history";

import { PATH_BOOK } from "./utils/paths";
import { CruiseBook } from "./modules/book";
import type { CoreCruisesCheckout } from "redmond";

/**
 * Cruise module App shell — a trimmed mirror of `experiences-module/src/App.tsx`.
 * Only the book route is wired; availability and shop for cruises are served by
 * the portal (`@capone/portal` CruisesApp).
 *
 * No Redux Provider yet: the page runs purely off the `core` prop (supplied by
 * the host's `useCruisesCheckoutProps()` call). Add a store, the
 * `@capone/checkout` workflow, and the ExperimentsProvider / AxiosInterceptors
 * chrome if/when this module owns real checkout state.
 */
export interface CruisesModuleProps {
  theme: Theme;
  language: string;
  baseHistory: History;
  core?: CoreCruisesCheckout;
}

const generateClassName = createGenerateClassName({
  productionPrefix: "ptCruisesModule",
  seed: "ptCruisesModule",
});

const App = (props: CruisesModuleProps) => {
  const { baseHistory, core } = props;
  const [activeTheme] = useState(props.theme);
  const [locale] = useState(props.language);

  return (
    <Router history={baseHistory}>
      <div className="App">
        <StylesProvider generateClassName={generateClassName}>
          <ThemeProvider theme={activeTheme}>
            <IntlProvider locale={locale} defaultLocale="en" messages={{}}>
              <Box className="main-section">
                <Route path={PATH_BOOK}>
                  <CruiseBook core={core} />
                </Route>
              </Box>
            </IntlProvider>
          </ThemeProvider>
        </StylesProvider>
      </div>
    </Router>
  );
};

export default App;
